"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mixins_exports = {};
__export(mixins_exports, {
  breakpointNext: () => breakpointNext,
  comboBoxStyles: () => comboBoxStyles,
  disabledComboBoxOptionStyles: () => disabledComboBoxOptionStyles,
  mediaBreakpointDown: () => mediaBreakpointDown,
  mediaBreakpointOnly: () => mediaBreakpointOnly,
  mediaBreakpointUp: () => mediaBreakpointUp,
  withBorder: () => withBorder,
  withBorderRadius: () => withBorderRadius,
  withBoxShadow: () => withBoxShadow,
  withBoxShadowBorder: () => withBoxShadowBorder,
  withFocus: () => withFocus,
  withInteraction: () => withInteraction,
  withMultipleOf: () => withMultipleOf,
  withPadding: () => withPadding,
  withScreenReaderOnlyText: () => withScreenReaderOnlyText,
  withStyledScrollBar: () => withStyledScrollBar
});
module.exports = __toCommonJS(mixins_exports);
var import_styled_components = require("styled-components");
var import_baseTheme = __toESM(require("./baseTheme"));
var withBorder = function withBorder2() {
  var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : import_baseTheme.default.colors.primary.base;
  var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : import_baseTheme.default.measurements.extraExtraSmall;
  return (0, import_styled_components.css)(["border:", " solid ", ";"], width, color);
};
var withBorderRadius = function withBorderRadius2() {
  var borderRadius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : import_baseTheme.default.measurements.small;
  var propertyNameSpace = arguments.length > 1 ? arguments[1] : void 0;
  var borderRadiusProperty = propertyNameSpace ? "var(".concat(propertyNameSpace, ", ").concat(borderRadius, ")") : "".concat(borderRadius);
  return (0, import_styled_components.css)(["border-radius:", ";"], borderRadiusProperty);
};
var withBoxShadow = function withBoxShadow2() {
  var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : import_baseTheme.default.colors.transparent.black;
  return (0, import_styled_components.css)(["box-shadow:2px 4px 10px ", ";"], color);
};
var withPadding = function withPadding2(paddings) {
  var interpolated = paddings.split(" ").reduce(function(result, measure) {
    return "".concat(result).concat(import_baseTheme.default.measurements[measure], " ");
  }, "");
  return (0, import_styled_components.css)(["padding:", ";"], interpolated);
};
var withInteraction = function withInteraction2(theme) {
  var darkMode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  return (0, import_styled_components.css)(["&:hover{background:", ";box-shadow:0 0 0 1px ", ";}&:active{background:", ";", "}&:focus{outline:none;-webkit-appearance:none;box-shadow:0 0 0 1px ", ";}"], darkMode ? "transparent" : theme.colors.neutral["light-30"], theme.colors.white, darkMode ? theme.colors.n["80"] : theme.colors.neutral.base, darkMode && "box-shadow: 0 0 0 1px ".concat(theme.colors.beige["180"], ";"), darkMode ? theme.colors.white : theme.colors.beige["180"]);
};
var withFocus = function withFocus2() {
  return (0, import_styled_components.css)(["outline:none;-webkit-appearance:none;box-shadow:", ";"], "".concat(import_baseTheme.default.colors.white, " ").concat(import_baseTheme.default.measurements.shadows.small, ",\n      ").concat(import_baseTheme.default.colors.primary["light-40"], " ").concat(import_baseTheme.default.measurements.shadows.medium));
};
var withMultipleOf = function withMultipleOf2(measure) {
  var multi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  var value = import_baseTheme.default.measurements[measure].split("px")[0];
  var multiple = parseInt(value, 10) * multi;
  return "".concat(multiple, "px");
};
var withScreenReaderOnlyText = function withScreenReaderOnlyText2() {
  return (0, import_styled_components.css)(["border:0;clip:rect(0,0,0,0);height:0;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;"]);
};
var scrollSizes = {
  extraThin: "8px",
  thin: "10px",
  wide: "14px"
};
var withStyledScrollBar = function withStyledScrollBar2() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref$scrollbarWidth = _ref.scrollbarWidth, scrollbarWidth = _ref$scrollbarWidth === void 0 ? "thin" : _ref$scrollbarWidth, _ref$scrollbarHeight = _ref.scrollbarHeight, scrollbarHeight = _ref$scrollbarHeight === void 0 ? "thin" : _ref$scrollbarHeight, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? import_baseTheme.default.colors.white : _ref$backgroundColor, _ref$darkModeBackgrou = _ref.darkModeBackground, darkModeBackground = _ref$darkModeBackgrou === void 0 ? void 0 : _ref$darkModeBackgrou, _ref$darkModeScrollba = _ref.darkModeScrollbar, darkModeScrollbar = _ref$darkModeScrollba === void 0 ? void 0 : _ref$darkModeScrollba, _ref$scrollbarColor = _ref.scrollbarColor, scrollbarColor = _ref$scrollbarColor === void 0 ? import_baseTheme.default.colors.n[100] : _ref$scrollbarColor;
  return (0, import_styled_components.css)(["::-webkit-scrollbar{width:", ";height:", ";}::-webkit-scrollbar-track{background:", ";}::-webkit-scrollbar-thumb{background-clip:padding-box;background:", ";border-radius:6px;border:", ";}::-webkit-scrollbar-thumb:hover{border:", ";}scrollbar-color:", " ", ";scrollbar-width:", ";"], scrollSizes[scrollbarWidth], scrollSizes[scrollbarHeight], darkModeBackground || backgroundColor, darkModeScrollbar || scrollbarColor, scrollbarWidth === "wide" ? "2px solid ".concat(backgroundColor) : "1px solid ".concat(backgroundColor, ";"), scrollbarWidth === "wide" ? "2px solid ".concat(backgroundColor) : "0px solid ".concat(backgroundColor, ";"), darkModeScrollbar || scrollbarColor, darkModeBackground || backgroundColor, scrollbarWidth);
};
var breakpoints = import_baseTheme.default.breakpoints;
var defaultReducedValue = "0.02px";
var breakpointNext = function breakpointNext2(size) {
  var keys = Object.keys(breakpoints);
  var nextIndex = keys.indexOf(size) + 1;
  var nextBreakpoint = keys[nextIndex];
  return breakpoints[nextBreakpoint];
};
var mediaBreakpointUp = function mediaBreakpointUp2(size, styles) {
  return (0, import_styled_components.css)(["@media (min-width:", "){", ";}"], breakpoints[size], styles);
};
var mediaBreakpointDown = function mediaBreakpointDown2(size, styles) {
  var reducedValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultReducedValue;
  return (0, import_styled_components.css)(["@media (max-width:calc(", " - ", ")){", ";}"], breakpointNext(size), reducedValue, styles);
};
var mediaBreakpointOnly = function mediaBreakpointOnly2(size, styles) {
  var reducedValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultReducedValue;
  return (0, import_styled_components.css)(["@media (min-width:", ") and (max-width:calc(", " - ", ")){", ";}"], breakpoints[size], breakpointNext(size), reducedValue, styles);
};
var disabledComboBoxOptionStyles = function disabledComboBoxOptionStyles2(theme) {
  return (0, import_styled_components.css)(["background:", ";cursor:not-allowed;color:", ";box-shadow:none;&:hover{background-color:", ";}"], theme.colors.n[10], theme.colors.n[60], theme.colors.n[10]);
};
var comboBoxStyles = function comboBoxStyles2(_ref2) {
  var theme = _ref2.theme, darkMode = _ref2.darkMode, isDisabled = _ref2.isDisabled, error = _ref2.error, borderLess = _ref2.borderLess;
  if (isDisabled) {
    return (0, import_styled_components.css)(["background-color:", ";color:", ";box-shadow:none;cursor:not-allowed;"], darkMode ? theme.colors.n[85] : theme.colors.n[10], darkMode ? theme.colors.n[30] : theme.colors.n[60]);
  }
  if (error) {
    return (0, import_styled_components.css)(["background-color:", ";color:", ";box-shadow:0 0 0 2px ", ";"], darkMode ? theme.colors.status.error[20] : theme.colors.white, theme.colors.n[100], theme.colors.status.error[100]);
  }
  return (0, import_styled_components.css)(["background-color:", ";color:", ";box-shadow:", ";"], darkMode ? theme.colors.n[100] : theme.colors.white, darkMode ? theme.colors.white : theme.colors.n[100], borderLess ? "none" : "0 0 0 1px ".concat(darkMode ? theme.colors.beige[140] : theme.colors.beige[180]));
};
var withBoxShadowBorder = function withBoxShadowBorder2() {
  var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : import_baseTheme.default.colors.primary.base;
  var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : import_baseTheme.default.measurements.extraExtraSmall;
  return (0, import_styled_components.css)(["box-shadow:0 0 0 ", " ", ";"], width, color);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  breakpointNext,
  comboBoxStyles,
  disabledComboBoxOptionStyles,
  mediaBreakpointDown,
  mediaBreakpointOnly,
  mediaBreakpointUp,
  withBorder,
  withBorderRadius,
  withBoxShadow,
  withBoxShadowBorder,
  withFocus,
  withInteraction,
  withMultipleOf,
  withPadding,
  withScreenReaderOnlyText,
  withStyledScrollBar
});
//# sourceMappingURL=mixins.js.map